import { createSlice } from "@reduxjs/toolkit";

const workflowLangSlice = createSlice({
  name: "workflowLang",
  initialState: "",
  reducers: {
    setWorkflowLang: (state, action) => {
      state = action.payload;
      return state;
    },
  },
});

export default workflowLangSlice;
